const color = {
  grey: "#777777",
  lightGrey: "#c2c6cc",
  medilinkColor: "#42556c",
  white: "#ffffff",
  //for wallet
  teal: "#007788",
  crimson: "#e40020",
  orange: "#fd9338",
  lightSeaGreen: "#00c69d",
  darkOrange: "#fe9807",
  blue: "#4b5f78"
};

export default color;
